module.exports = __webpack_public_path__ + "img/icon-category-light.768d2596.svg";